import React, { useState } from 'react';

const semifinalists = [
  "Zahra Abbas", "Muhammad Abbas", "Mohamed Ramadan Abdelhamed", "Muhammad Abdullah",
  "Ayan Abid", "Zhaniya Abubakirova", "Muhammad Adil", "Eliza Adnan",
  "Ibrahim Adnan", "Sadia Afrose", "Javeria Afzaal", "Akshay Agarwal",
  "Mehul Agrawal", "Zainab Ahmed", "Farhan Tanveer Ahmed", "Noor ul Ain",
  "Shyntas Aityk", "Mohammed Abdulmajeed Albalawi", "Fayyaz Ali", "Izhar Ali",
  "Syed Hasaan Ali", "Jeena Ali", "Hagar Antar", "Muhammad Yahya Arif",
  "Muhammad Arish", "Maria Gianella Farfan Asenjo", "Ayesha Asghar", "Ahmad Abdullah Ashraf",
  "Muhammad Ayan Asif", "Adeem Asim", "Niya Aslam", "Mikebayev Assanali",
  "Zartasha Ateeq", "Muhammad Atiq-ur-Rehman", "Aryan Atri", "Youssef Ayman",
  "Tejas Bachu", "Krish Bahl", "Sanjay Bandaru", "Justine Keeno M. Batulan",
  "Safiyanur Beket", "Fatima Bhatti", "Kuldeep Bind", "Bora Bogdan",
  "Yelizaveta Bykovskaya", "Allison Cerron", "Muhammad Ahmed Chaudhary", "Hanbyeol Cho",
  "Aaron Choi", "Kanishk Choudhary", "Daim", "Daniyal",
  "Zayena Fatima Dar", "Ivy Datta", "Rakhmatulla Daud", "Wesley Deheck",
  "Anyulina Arias Delvaty", "Aryaveer Desai", "Aarav Dewan", "Huy Du",
  "Samura Ejaz", "Muyyid Ejaz", "Eman", "Khadija Faisal",
  "Wafa Faisal", "Zaki Farhat", "Inaya Farrukh", "Aimen Fatima",
  "Areej Fatima", "Zaib Fatima", "Manahil Fatima",
  "Madelyn Feng", "Yik Chun Fong", "Hayley Foo", "Beza Gary Galton", "Mafdy Gamil",
  "Arjun Garg", "Arian Goruk", "Krishna Gupta", "Paulean Amelly Mikowle M. De Guzman",
  "Alessandro Haber", "Ehab Hafez", "Zeeshan Haider", "Abdallah Mohamed Abd El Hady Hamed",
  "Ali Hamza", "Ali Hamza", "Muhammad Haris", "Muhammad Hassam",
  "Muhammad Rayyan Hassan", "Friederike Henkel", "Arang Hong", "Poli Hsu",
  "Muzzammil Hussain", "Ahmed Ibraheem", "Farwa Ijaz", "Fatima Ishtiaq",
  "Ayesha Jabbar", "Parikshitsinh Jadeja", "Dhruv Jain", "Aashvi Jain",
  "Neil Jain", "Neva Jain", "Vihaan Jain", "Garima Jain",
  "Tehreem Javaid", "Muhammad Husnain Javed", "Maveen Javed", "Sania Javed",
  "Rishav Anand Kumar Jha", "Kaylee Jin", "Chloe Mary Jreije", "Abrish Junaid",
  "Ayazhan Kabdullina", "Taalai Kabylov", "Dariya Kairbayeva", "Zhaniya Kaliyeva",
  "Rithvik Sai Reddy Kambham", "Sandy Kamhawy", "Radmila Kanumuru", "Buttey Arun Karthikeya",
  "Zain Kashif", "Khadija", "Amira Selpa Khairunnisa", "Zainab Khalid",
  "Waheed Khalid", "Kenzy Ramy Atef Khallaf", "Mekaiel Khan", "Hessan ud Din Khan",
  "Muhammad Sufiyan Khan", "Zain Ali Khan", "Manaswi Kolla", "Alfarabi Kuat",
  "Roma Shree Dinesh Kumar", "Aklavya Kumar", "Dhyey Kumawat", "Anika Kurup",
  "Eaint Hay Thar Kyaw", "Omorov Kylymdar", "Laiba", "Aanya Lamba",
  "Timur Li", "Chelsea Lian", "M. Azaan Ahmed", "Monica Grenadier Macaes",
  "Advika Madhusudan", "Nurberdi Magripetollaev", "Radhana Mainali", "Julia Maksimowicz",
  "Chetna Malga", "Nursultan Mamazhanov", "Misbah Mansoor", "Zyna Manzar",
  "Amna Masood", "Shaurya Mathur", "Merey Meiirkhan", "M Daniyal Minhas",
  "Vriti Mirchandani", "Shashwat Mishra", "Rianna Mitra", "Shahd Hossam Salama Mohamed",
  "Sahil Mohammed", "Abhijeet More", "Shamroz Mughal", "Usman Mughal",
  "Daniya Mukhambetzhan", "Shreya Munjal", "Shashank Kailash Muthuraju", "Aman Muzaffar",
  "Ho Le Nam", "Tleubergen Nariman", "Hafiz Ch Muhammad Wahaj Naseem", "Merey Nazarbay",
  "Abduakhitova Naziya", "Zhanel Niyazbekova", "Sehar Noor", "Nahid Noufal",
  "Gilman Nurym", "Alua Nurzhigit", "Zan Htet Nway", "Alisha Oberoi",
  "Muhammad Osaid", "Daria Palichov", "Adithya Pammi", "Matthew Park",
  "Dhanvin Patel", "Anica Patel", "Claire Peng", "Timur Petanin",
  "Rithvik Puppala", "Ibrahim Qamar", "Rohan Qureshi", "Saeha Midrar Ullah Qureshi",
  "Anoushka Rai", "Shumail Qammar Raja", "Muhammad Ibrahim Raja", "Hari Rangarajan",
  "Maryam Rashid", "Aritra Ray", "Bisma Raza", "Annika Razdan",
  "Momna Razzaq", "Kethan Reddy", "Abdul Rehman", "Abdul Rehman",
  "Liana Ren", "Muhammad Reyan", "Noor Rizvi", "Rupkatha Roy",
  "Syeda Areeza Rubab", "Anna Rychtera", "Arya Sachan", "Muhammad Shahab Saffi",
  "Bilal Sajid", "Muhammad Ahmed Sajid", "Saadullah Sajjad", "Kavya Sanghavi",
  "Jash Sanghavi", "Varuni Saranu", "Syed Sarim", "Anvi Sarmah",
  "Joseph Sawwan", "Melis Helen Serbest", "Ateeba Shabbir", "Syed Muhammad Musa Shah",
  "Muhammad Shayan Shah", "Syed Barkat ul Husnain Shah", "Laiba Shahid", "Amina Shahid",
  "Sania Shahid", "Adnan Shakeel", "Shan-e-Ahmed", "Saqlain Shareef",
  "Pari Sharma", "Malik Kashif Shehzad", "Yashfeen Shehzadi", "Maha Sheikh",
  "Samat Shigabiev", "Ayesha Siddiq", "Aima Sidra", "Ihar Sinelchankau",
  "Aaradhya Singh", "Dhanraj Singh", "Mehai Singh", "Aditya Singhal",
  "Srividya Siripurapu", "Malavika Sreehari", "Subhan", "Daniya Suleimenova",
  "Bushra Suleman", "Malleshwar Jayaraman Suresh", "Suryatej Suryadevara", "Sehar Syed",
  "Aiza Syed", "Kshiti Tadimarri", "Alina Tahir", "Fatima Tanveer",
  "Iqra Tasleem", "Deniza Temerbekova", "Zere Temirkhan", "Aashrith Sai Thoutham",
  "Wong Tsun To", "Aldiyar Toleugazy", "Sharvi Tripathi", "Anayat Ullah",
  "Naseeb Ullah", "Muhammad Anas Umer", "Anastassiya Urmantseva", "Muhammad Uzair",
  "Muhammad Uzair", "Andrey Vasilyev", "Sahaana Vasudevan", "Nikita Vijay",
  "Pratham Vohra", "Vrishank", "Kelong Wang", "Ruoyi Wang",
  "Charlie Wang", "Aaron Wang", "Khushi Warkade", "Zunaira Wasi",
  "Julius Whaley", "Charlotte Wong", "Chloe Wu", "Huaze Xin",
  "Anvith Yalamanchili", "Kyle Yang", "Alikhan Yerekeshov", "Temirkhan Yeskenov",
  "Yusra", "Zainab", "Samiha Zaman", "Daniyal Zangirov",
  "Sophia Zhang", "Michelle Zhou",
];

function Semifinals2026() {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredNames = semifinalists.filter(name =>
    name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div>
      {/* Header Section */}
      <div style={{ marginBottom: '40px' }}>
        <span style={{
          display: 'inline-block',
          padding: '6px 14px',
          borderRadius: '6px',
          backgroundColor: 'rgba(0, 77, 153, 0.08)',
          color: '#004d99',
          fontSize: '0.85rem',
          fontWeight: '600',
          marginBottom: '16px'
        }}>
          March 2026
        </span>
        <h2 style={{
          fontSize: '2rem',
          fontWeight: '600',
          color: '#1a1a2e',
          marginBottom: '16px'
        }}>
          2026 Semi-Finalists
        </h2>
        <p style={{ fontSize: '1.05rem', color: '#555', lineHeight: '1.7', marginBottom: '16px' }}>
          <strong>Congratulations to the IRO semi-finalists!</strong> The top 10% of participants have advanced to the semifinals round.
        </p>
        <div style={{
          background: 'rgba(0, 77, 153, 0.06)',
          borderLeft: '4px solid #004d99',
          borderRadius: '8px',
          padding: '16px 20px'
        }}>
          <p style={{ fontSize: '0.95rem', color: '#1a1a2e', lineHeight: '1.7', margin: 0 }}>
            Certificates for the 2026 IRO are now available — visit the Certificate page (in the top menu) and enter the email you registered with to view and download yours.
          </p>
        </div>
      </div>

      {/* Quote Card */}
      <div style={{
        background: '#f8f9fa',
        borderRadius: '16px',
        padding: '32px',
        marginBottom: '40px',
        borderLeft: '4px solid #004d99'
      }}>
        <p style={{ fontSize: '1rem', color: '#555', lineHeight: '1.8', fontStyle: 'italic', marginBottom: '12px' }}>
          "We believe your potential in research is unlimited and deep. We stand committed to making this community into a close, innovative, welcoming, and supportive society around student research aspirations."
        </p>
        <p style={{ fontSize: '0.95rem', color: '#1a1a2e', fontWeight: '600', margin: 0 }}>
          — Rishab Jain, President, IRO
        </p>
      </div>

      {/* Stats */}
      <div style={{
        display: 'flex',
        gap: '20px',
        marginBottom: '40px',
        flexWrap: 'wrap'
      }}>
        <div style={{
          background: '#fff',
          borderRadius: '12px',
          padding: '24px 32px',
          boxShadow: '0 4px 15px rgba(0, 0, 0, 0.06)',
          border: '1px solid #e8eef3',
          textAlign: 'center'
        }}>
          <p style={{
            fontSize: '2.5rem',
            fontWeight: '700',
            color: '#004d99',
            margin: '0 0 4px 0',
            lineHeight: '1'
          }}>
            {semifinalists.length}
          </p>
          <p style={{ fontSize: '0.9rem', color: '#666', margin: 0 }}>Semi-Finalists</p>
        </div>
        <div style={{
          background: '#fff',
          borderRadius: '12px',
          padding: '24px 32px',
          boxShadow: '0 4px 15px rgba(0, 0, 0, 0.06)',
          border: '1px solid #e8eef3',
          textAlign: 'center'
        }}>
          <p style={{
            fontSize: '2.5rem',
            fontWeight: '700',
            color: '#004d99',
            margin: '0 0 4px 0',
            lineHeight: '1'
          }}>
            Top 10%
          </p>
          <p style={{ fontSize: '0.9rem', color: '#666', margin: 0 }}>Of All Participants</p>
        </div>
      </div>

      {/* Search */}
      <div style={{ marginBottom: '30px' }}>
        <input
          type="text"
          placeholder="Search for a name..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            width: '100%',
            maxWidth: '400px',
            padding: '14px 20px',
            fontSize: '1rem',
            border: '1px solid #e8eef3',
            borderRadius: '10px',
            outline: 'none',
            transition: 'border-color 0.2s ease',
          }}
          onFocus={(e) => e.target.style.borderColor = '#004d99'}
          onBlur={(e) => e.target.style.borderColor = '#e8eef3'}
        />
      </div>

      {/* Names Grid */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
        gap: '12px'
      }}>
        {filteredNames.map((name, index) => (
          <div key={index} style={{
            background: '#fff',
            borderRadius: '8px',
            padding: '14px 18px',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
            border: '1px solid #e8eef3',
            fontSize: '0.95rem',
            color: '#1a1a2e',
            fontWeight: '500'
          }}>
            {name}
          </div>
        ))}
      </div>

      {filteredNames.length === 0 && (
        <p style={{ textAlign: 'center', color: '#666', marginTop: '40px' }}>
          No results found for "{searchTerm}"
        </p>
      )}
    </div>
  );
}

export default Semifinals2026;
